import { render } from "./ShowListDichVuCong.vue?vue&type=template&id=33f9a34d&ts=true"
import script from "./ShowListDichVuCong.vue?vue&type=script&lang=ts"
export * from "./ShowListDichVuCong.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA/ZaloNHS/ZaloQUAN_NHS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__